var util_gw_array0 = "(GMT-12:00)Eniwetok, Kwajalein";
var util_gw_array1 = "(GMT-11:00)Midway Island, Samoa";
var util_gw_array2 = "(GMT-10:00)Hawaii";
var util_gw_array3 = "(GMT-09:00)Alaska";
var util_gw_array4 = "(GMT-08:00)Pacific Time (US & Canada); Tijuana";
var util_gw_array5 = "(GMT-07:00)Arizona";
var util_gw_array6 = "(GMT-07:00)Mountain Time (US & Canada)";
var util_gw_array7 = "(GMT-06:00)Central Time (US & Canada)";
var util_gw_array8 = "(GMT-06:00)Mexico City, Tegucigalpa";
var util_gw_array9 = "(GMT-06:00)Saskatchewan";
var util_gw_array10 = "(GMT-05:00)Bogota, Lima, Quito";
var util_gw_array11 = "(GMT-05:00)Eastern Time (US & Canada)";
var util_gw_array12 = "(GMT-05:00)Indiana (East)";
var util_gw_array13 = "(GMT-04:00)Atlantic Time (Canada)";
var util_gw_array14 = "(GMT-04:00)Caracas, La Paz";
var util_gw_array15 = "(GMT-04:00)Santiago";
var util_gw_array16 = "(GMT-03:30)Newfoundland";
var util_gw_array17 = "(GMT-03:00)Brasilia";
var util_gw_array18 = "(GMT-03:00)Buenos Aires, Georgetown";
var util_gw_array19 = "(GMT-02:00)Mid-Atlantic";
var util_gw_array20 = "(GMT-01:00)Azores, Cape Verde Is.";
var util_gw_array21 = "(GMT)Casablanca, Monrovia";
var util_gw_array22 = "(GMT)Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London";
var util_gw_array23 = "(GMT+01:00)Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna";
var util_gw_array24 = "(GMT+01:00)Belgrade, Bratislava, Budapest, Ljubljana, Prague";
var util_gw_array25 = "(GMT+01:00)Barcelona, Madrid";
var util_gw_array26 = "(GMT+01:00)Brussels, Copenhagen, Madrid, Paris, Vilnius";
var util_gw_array27 = "(GMT+01:00)Paris";
var util_gw_array28 = "(GMT+01:00)Sarajevo, Skopje, Sofija, Warsaw, Zagreb";
var util_gw_array29 = "(GMT+02:00)Athens, Istanbul, Minsk";
var util_gw_array30 = "(GMT+02:00)Bucharest";
var util_gw_array31 = "(GMT+02:00)Cairo";
var util_gw_array32 = "(GMT+02:00)Harare, Pretoria";
var util_gw_array33 = "(GMT+02:00)Helsinki, Riga, Tallinn";
var util_gw_array34 = "(GMT+02:00)Jerusalem";
var util_gw_array35 = "(GMT+03:00)Baghdad, Kuwait, Riyadh";
var util_gw_array36 = "(GMT+03:00)Moscow, St. Petersburg, Volgograd";
var util_gw_array37 = "(GMT+03:00)Mairobi";
var util_gw_array38 = "(GMT+03:30)Tehran";
var util_gw_array39 = "(GMT+04:00)Abu Dhabi, Muscat";
var util_gw_array40 = "(GMT+04:00)Baku, Tbilisi";
var util_gw_array41 = "(GMT+04:30)Kabul";
var util_gw_array42 = "(GMT+05:00)Ekaterinburg";
var util_gw_array43 = "(GMT+05:00)Islamabad, Karachi, Tashkent";
var util_gw_array44 = "(GMT+05:30)Bombay, Calcutta, Madras, New Delhi";
var util_gw_array45 = "(GMT+06:00)Astana, Almaty, Dhaka";
var util_gw_array46 = "(GMT+06:00)Colombo";
var util_gw_array47 = "(GMT+07:00)Bangkok, Hanoi, Jakarta";
var util_gw_array48 = "(GMT+08:00)Beijing, Chongqing, Hong Kong, Urumqi";
var util_gw_array49 = "(GMT+08:00)Perth";
var util_gw_array50 = "(GMT+08:00)Singapore";
var util_gw_array51 = "(GMT+08:00)Taipei";
var util_gw_array52 = "(GMT+09:00)Osaka, Sapporo, Tokyo";
var util_gw_array53 = "(GMT+09:00)Seoul";
var util_gw_array54 = "(GMT+09:00)Yakutsk";
var util_gw_array55 = "(GMT+09:30)Adelaide";
var util_gw_array56 = "(GMT+09:30)Darwin";
var util_gw_array57 = "(GMT+10:00)Brisbane";
var util_gw_array58 = "(GMT+10:00)Canberra, Melbourne, Sydney";
var util_gw_array59 = "(GMT+10:00)Guam, Port Moresby";
var util_gw_array60 = "(GMT+10:00)Hobart";
var util_gw_array61 = "(GMT+10:00)Vladivostok";
var util_gw_array62 = "(GMT+11:00)Magadan, Solomon Is., New Caledonia";
var util_gw_array63 = "(GMT+12:00)Auckland, Wllington";
var util_gw_array64 = "(GMT+12:00)Fiji, Kamchatka, Marshall Is.";

function ntp_entry(name, value) {
    this.name = name;
    this.value = value;
}

var ntp_zone_array = new Array(65);
ntp_zone_array[0] = new ntp_entry(util_gw_array0, "12 1");
ntp_zone_array[1] = new ntp_entry(util_gw_array1, "11 1");
ntp_zone_array[2] = new ntp_entry(util_gw_array2, "10 1");
ntp_zone_array[3] = new ntp_entry(util_gw_array3, "9 1");
ntp_zone_array[4] = new ntp_entry(util_gw_array4, "8 1");
ntp_zone_array[5] = new ntp_entry(util_gw_array5, "7 1");
ntp_zone_array[6] = new ntp_entry(util_gw_array6, "7 2");
ntp_zone_array[7] = new ntp_entry(util_gw_array7, "6 1");
ntp_zone_array[8] = new ntp_entry(util_gw_array8, "6 2");
ntp_zone_array[9] = new ntp_entry(util_gw_array9, "6 3");
ntp_zone_array[10] = new ntp_entry(util_gw_array10, "5 1");
ntp_zone_array[11] = new ntp_entry(util_gw_array11, "5 2");
ntp_zone_array[12] = new ntp_entry(util_gw_array12, "5 3");
ntp_zone_array[13] = new ntp_entry(util_gw_array13, "4 1");
ntp_zone_array[14] = new ntp_entry(util_gw_array14, "4 2");
ntp_zone_array[15] = new ntp_entry(util_gw_array15, "4 3");
ntp_zone_array[16] = new ntp_entry(util_gw_array16, "3 1");
ntp_zone_array[17] = new ntp_entry(util_gw_array17, "3 2");
ntp_zone_array[18] = new ntp_entry(util_gw_array18, "3 3");
ntp_zone_array[19] = new ntp_entry(util_gw_array19, "2 1");
ntp_zone_array[20] = new ntp_entry(util_gw_array20, "1 1");
ntp_zone_array[21] = new ntp_entry(util_gw_array21, "0 1");
ntp_zone_array[22] = new ntp_entry(util_gw_array22, "0 2");
ntp_zone_array[23] = new ntp_entry(util_gw_array23, "-1 1");
ntp_zone_array[24] = new ntp_entry(util_gw_array24, "-1 2");
ntp_zone_array[25] = new ntp_entry(util_gw_array25, "-1 3");
ntp_zone_array[26] = new ntp_entry(util_gw_array26, "-1 4");
ntp_zone_array[27] = new ntp_entry(util_gw_array27, "-1 5");
ntp_zone_array[28] = new ntp_entry(util_gw_array28, "-1 6");
ntp_zone_array[29] = new ntp_entry(util_gw_array29, "-2 1");
ntp_zone_array[30] = new ntp_entry(util_gw_array30, "-2 2");
ntp_zone_array[31] = new ntp_entry(util_gw_array31, "-2 3");
ntp_zone_array[32] = new ntp_entry(util_gw_array32, "-2 4");
ntp_zone_array[33] = new ntp_entry(util_gw_array33, "-2 5");
ntp_zone_array[34] = new ntp_entry(util_gw_array34, "-2 6");
ntp_zone_array[35] = new ntp_entry(util_gw_array35, "-3 1");
ntp_zone_array[36] = new ntp_entry(util_gw_array36, "-3 2");
ntp_zone_array[37] = new ntp_entry(util_gw_array37, "-3 3");
ntp_zone_array[38] = new ntp_entry(util_gw_array38, "-3 4");
ntp_zone_array[39] = new ntp_entry(util_gw_array39, "-4 1");
ntp_zone_array[40] = new ntp_entry(util_gw_array40, "-4 2");
ntp_zone_array[41] = new ntp_entry(util_gw_array41, "-4 3");
ntp_zone_array[42] = new ntp_entry(util_gw_array42, "-5 1");
ntp_zone_array[43] = new ntp_entry(util_gw_array43, "-5 2");
ntp_zone_array[44] = new ntp_entry(util_gw_array44, "-5 3");
ntp_zone_array[45] = new ntp_entry(util_gw_array45, "-6 1");
ntp_zone_array[46] = new ntp_entry(util_gw_array46, "-6 2");
ntp_zone_array[47] = new ntp_entry(util_gw_array47, "-7 1");
ntp_zone_array[48] = new ntp_entry(util_gw_array48, "-8 1");
ntp_zone_array[49] = new ntp_entry(util_gw_array49, "-8 2");
ntp_zone_array[50] = new ntp_entry(util_gw_array50, "-8 3");
ntp_zone_array[51] = new ntp_entry(util_gw_array51, "-8 4");
ntp_zone_array[52] = new ntp_entry(util_gw_array52, "-9 1");
ntp_zone_array[53] = new ntp_entry(util_gw_array53, "-9 2");
ntp_zone_array[54] = new ntp_entry(util_gw_array54, "-9 3");
ntp_zone_array[55] = new ntp_entry(util_gw_array55, "-9 4");
ntp_zone_array[56] = new ntp_entry(util_gw_array56, "-9 5");
ntp_zone_array[57] = new ntp_entry(util_gw_array57, "-10 1");
ntp_zone_array[58] = new ntp_entry(util_gw_array58, "-10 2");
ntp_zone_array[59] = new ntp_entry(util_gw_array59, "-10 3");
ntp_zone_array[60] = new ntp_entry(util_gw_array60, "-10 4");
ntp_zone_array[61] = new ntp_entry(util_gw_array61, "-10 5");
ntp_zone_array[62] = new ntp_entry(util_gw_array62, "-11 1");
ntp_zone_array[63] = new ntp_entry(util_gw_array63, "-12 1");
ntp_zone_array[64] = new ntp_entry(util_gw_array64, "-12 2");


export default ntp_zone_array